import React from "react";
import { Avatar } from "@mui/material";
import { Rating, Box, Grid } from "@mui/material";

const ProductReviewCard = ({ items = [] }) => {
  console.log("items in review card", items);
  if (!items.length) {
    return <p className="text-gray-500">No customer reviews yet.</p>;
  }

  return (
    <div className="space-y-6">
      {items.map((rev) => (
        <Grid container spacing={2} gap={3} key={rev._id}>
          <Grid item xs={1}>
            <Box>
              <Avatar
                className="text-white"
                sx={{ width: 56, height: 56, bgcolor: "#9155FD" }}
                alt={rev.user?.firstName}
              >
                {rev.user?.firstName?.[0]?.toUpperCase()}
              </Avatar>
            </Box>
          </Grid>

          <Grid item xs={9}>
            <div className="space-y-2">
              <div>
                <p className="font-semibold text-lg">
                  {rev.user?.firstName} {rev.user?.lastName}
                </p>
                <p className="opacity-70 text-sm">
                  {new Date(rev.createdAt).toLocaleDateString()}
                </p>
              </div>

              <div>
                <Rating
                  value={rev.rating || 4.5} // agar rating field mile to wo show kare
                  precision={0.5}
                  readOnly
                />
              </div>

              <p className="text-gray-700">{rev.review}</p>
            </div>
          </Grid>
        </Grid>
      ))}
    </div>
  );
};

export default ProductReviewCard;
